"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CachePromise;
const companyCache = {};
function CachePromise(authState) {
  return function (name, fn) {
    // pull the company id from the context
    const {
      company_id
    } = authState.claims;
    // if the company doesn't have a cache yet, make it
    if (!companyCache[company_id]) {
      companyCache[company_id] = {};
    }
    // get the company cache
    const promiseCache = companyCache[company_id];
    // if the function has been run return the existing promise
    // otherwise run the function and return the result
    return async () => {
      if (!promiseCache[name]) {
        promiseCache[name] = fn();
      }
      return promiseCache[name];
    };
  };
}
//# sourceMappingURL=promise-cache.js.map